import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import axios from 'axios';

const API_BASE = "https://pinballscoresapp-ayd8babtd4fpadec.eastus2-01.azurewebsites.net";

const TableList = ({ onSelectTable, machineFilters }) => {
  const [tableOptions, setTableOptions] = useState([]);
  const [allTables, setAllTables] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API_BASE}/api/tables`)
      .then(res => {
        setAllTables(res.data);
        setLoading(false);
      })
      .catch(err => {
        console.error('Error fetching tables:', err);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    if (!allTables.length) return;
    
    // Filter tables based on machineFilters
    const filteredTables = allTables.filter(table => {
      if (!machineFilters) return true;
      const isVirtual = table.Type === 'FX' || table.Type === 'VPX';
      const isRetro = table.Type === 'Retro';
      const isReal = !isVirtual && !isRetro;
      
      if (isReal && !machineFilters.real) return false;
      if (isVirtual && !machineFilters.virtual) return false;
      if (isRetro && !machineFilters.retro) return false;
      return true;
    });

    const uniqueNames = [...new Set(filteredTables.map(table => table.Name))];
    const options = uniqueNames.map(name => ({
      value: name,
      label: name
    }));
    setTableOptions(options);
  }, [allTables, machineFilters]);

  const formatOptionLabel = ({ label }) => {
    if (!label || !label.includes('&')) return label;
    const parts = label.split('&');
    return (
      <span>
        {parts.map((part, i) => (
          <React.Fragment key={i}>
            {part}
            {i < parts.length - 1 && (
              <span style={{ color: '#888', fontWeight: 'normal', opacity: 0.75, margin: '0 2px' }}>&</span>
            )}
          </React.Fragment>
        ))}
      </span>
    );
  };

  const handleChange = (option) => {
    setSelectedOption(option);
    if (onSelectTable && option) {
      onSelectTable(option.value);
    }
  };

  return (
    <div className="table-select-container">
      
      {loading ? (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
          <div className="small-spinner" style={{ margin: '0' }}></div>
          <h3 style={{ margin: '0' }}>Loading tables...</h3>
        </div>
      ) : (
        <Select
          classNamePrefix="react-select"
          options={tableOptions}
          value={selectedOption}
          onChange={handleChange}
          formatOptionLabel={formatOptionLabel}
          placeholder="Search or select a machine..."
          isClearable
        />
      )}
    </div>
  );
};

export default TableList;